module.exports = __webpack_public_path__ + "media/images/Cata-12-2f4353c7f022b5bed10f497e2edb4180.jpg";